import type { Metadata } from "next";
import Login from "@/Component/Auth/Login";

export const metadata: Metadata = {
    title: "Admin Login | Connector Club",
    description: "",
};

const LoginPage = () => {
    return (
        <Login role="admin" />
    )
}

export default LoginPage
